import {environmentConfig} from "../config/enviromentConfig";
import axios from "axios";

export default class UtilsService {
    static async getMsisdnFromEncryptedMsisdn(encryptedMsisdn) {
        return await axios.post(`${environmentConfig.utilsService}/userDataDecryption/decryptenrichedmsisdn?encryptedMsisdn=${encryptedMsisdn}`);
    }
}
